export default {"src":"/_next/static/media/risk.68375ed4.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};